import { useMemo, type ReactNode } from 'react';
import { grafanaApiRef } from '@backstage-community/plugin-grafana';
import { ApiProvider } from '@backstage/core-app-api';
import {
  configApiRef,
  useApi,
  useApiHolder,
  type ApiHolder,
  type ApiRef,
} from '@backstage/core-plugin-api';
import { withOrgId } from './orgWrapper';

// Substitutes grafanaApiRef for the wrapped subtree with the real client plus
// orgId on every link (see orgWrapper.ts). Everything else resolves through
// the parent holder.
export const OrgScopedGrafana = ({ children }: { children: ReactNode }) => {
  const parent = useApiHolder();
  const api = useApi(grafanaApiRef);
  const config = useApi(configApiRef);
  const holder = useMemo<ApiHolder>(() => {
    const wrapped = withOrgId(api, config);
    return {
      get: <T,>(ref: ApiRef<T>) =>
        (ref.id === grafanaApiRef.id ? wrapped : parent.get(ref)) as
          | T
          | undefined,
    };
  }, [api, config, parent]);
  return <ApiProvider apis={holder}>{children}</ApiProvider>;
};
